
<div [id]="editorId" [ngStyle]="{'min-height': height, 'height': height }">

</div>

